import React from 'react';
import ReactDOM from 'react-dom/client';
import ComponentBasedApp from "./captain/ComponentBasedApp";
import Chain from "./captain/Chain";
import System from "./helper/system";
import { Route, Routes } from "react-router-dom";
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import RoleAndPermission from './helper/RoleAndPermission';
import '../src/styles/main.scss'

const RouteBasedApp = React.lazy(() => import("./captain/RouteBasedApp"));

window.mct = 'EUR';
window.mcs = getSymbolFromCurrency(window.mct);
require('./helper/modal');
System.setWindow_avUserInfo_cookie_name();

window.ltpaToken = ''

if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes') {
    loadReact(
        document.getElementById('root'),
        <RouteBasedApp />
    );
}

const c = new ComponentBasedApp().getComponent();
// console.log('line 47', c)
c.map((v) => {
    //currently may be not in use
    let DomID = 'react_' + System.camelToUnderscore(v.name);
    loadReact(
        document.getElementById(DomID),
        React.createElement(v.element)
    );
    // check and map all the component & load
    let DomName = 'React' + v.name;
    // console.log('dom name', DomName)
    let tags = document.querySelectorAll(DomName); // Find tag from Dom (e.g. <reactUniversalSearch> set from dx )
    // console.log('tags', tags)
    let chaining = [];
    if (tags.length) { // load all the compoent which are getting from DOM(Dx) // get component from our system
        Array.prototype.slice.call(tags).forEach(function (elementHere) {
            chaining.push({
                tag: elementHere,
                dom: v.element,
            })
        });
    }
    if (chaining.length) {
        // console.log('line 67', chaining)
        chaining.map((cIn) => {
            loadReact(
                cIn.tag,
                <Routes>
                    <Route path="*" exact={true} element={
                        <>
                            {/* {console.log('line 74', cIn.dom)} */}
                            {React.createElement(cIn.dom)}
                        </>
                    } />
                </Routes>
            );
        })
    }
});


async function loadReact(domElement, BaseApp) {
    RoleAndPermission.loadPermissionBasedOnAuthRole()
    //console.log('start line 84', domElement)
    if (domElement) {
        //console.log("Start Loading Dom Element");
        const root = ReactDOM.createRoot(domElement);
        root.render(<div className={'isolated_react_app'}>
            <Chain>
                {BaseApp}
            </Chain>
        </div>)
    }
}
